var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('LlAppFixedToolBar'),_c('LlScrollableWrap',[_c('LlScrollableBlock',{attrs:{"title":"管理"}},[_c('ImgButtonList',{attrs:{"isRow":"","size":"middle","buttonList":_vm._managementButton}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }